/* Sticky add-to-cart bar (mobile). See snippets/cfw-pdp-sticky-atc.liquid. */
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('cfw-satc');
    var main = document.getElementById('pdp-add-to-cart');
    if (!bar || !main) return;
    var btn = bar.querySelector('[data-satc-btn]');
    var price = bar.querySelector('[data-satc-price]');
    var picker = document.getElementById('pdp-size-picker-wrap');
    var mq = window.matchMedia('(max-width: 989px)');
    var mainAbove = false;   // main ATC has scrolled above the viewport
    var mainOn = false;      // main ATC visible
    var pickerOn = false;    // size picker visible

    function render(state) {
      if (!state) return;
      if (price) price.textContent = state.priceLabel || price.textContent;
      if (!btn) return;
      if (!state.available && state.complete) {
        btn.textContent = 'Sold out – call us';
        btn.dataset.mode = 'call';
      } else if (!state.complete) {
        btn.textContent = state.needs === 'size' ? 'Choose size' : (state.needs === 'width' ? 'Choose width' : 'Choose options');
        btn.dataset.mode = 'choose';
      } else {
        btn.textContent = 'Add to cart';
        btn.dataset.mode = 'add';
      }
    }

    function sync() {
      var show = mq.matches && mainAbove && !mainOn && !pickerOn;
      if (show === !bar.hidden) return;
      bar.hidden = !show;
      document.body.classList.toggle('cfw-satc-on', show);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          mainOn = e.isIntersecting;
          mainAbove = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        });
        sync();
      }, { threshold: 0 }).observe(main);
      if (picker) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { pickerOn = e.isIntersecting; });
          sync();
        }, { threshold: 0 }).observe(picker);
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', sync);

    if (btn) {
      btn.addEventListener('click', function () {
        var api = window.cfwPdp;
        if (btn.dataset.mode === 'call') { window.location.href = 'tel:+17048460301'; return; }
        if (!api) { main.scrollIntoView({ block: 'center' }); return; }
        if (btn.dataset.mode === 'add') {
          var old = btn.textContent;
          btn.textContent = 'Adding…';
          api.addToCart().then(function (ok) {
            btn.textContent = ok ? 'Added ✓' : old;
            setTimeout(function () { render(api.getState()); }, 2000);
          });
        } else {
          api.showRequiredError();
        }
      });
    }

    document.addEventListener('cfw:pdp:state', function (e) { render(e.detail); });
    if (window.cfwPdp) render(window.cfwPdp.getState());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
